import React from "react";
import cprog from "../../img/cprogramming.png";
import java from "../../img/java.png";
import python from "../../img/python.png";
import html from "../../img/html.png";
import css from "../../img/css.png";
import javascript from "../../img/javascript.png";
import bootstrap from "../../img/bootstrap.png";
import react from "../../img/react.png";
import redux from "../../img/redux.png";
import firebase from "../../img/firebase.png";

const Skills = () => {
	return (
		<div className="skills_wrapper">
			<div className="header">My Skills</div>
			<div className="skills">
				<div className="programming">
					<h2>Programming </h2>
					<ul className="p_skills">
						<li>
							<img src={cprog} alt="cprogramming" />
						</li>
						<li>
							<img src={java} alt="java" />
						</li>
						<li>
							<img src={python} alt="python" />
						</li>
					</ul>
				</div>
				<div className="programming">
					<h2>Web development </h2>
					<ul className="p_skills">
						<li>
							<img src={html} alt="html" />
						</li>
						<li>
							<img src={css} alt="css" />
						</li>
						<li>
							<img src={javascript} alt="javascript" />
						</li>
						<li>
							<img src={bootstrap} alt="bootstrap" />
						</li>
						<li>
							<img src={react} alt="react" />
						</li>
						<li>
							<img src={redux} alt="redux" />
						</li>
						<li>
							<img src={firebase} alt="firebase" />
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};

export default Skills;
